import { render } from "./Index.vue?vue&type=template&id=27e0c937&scoped=true&lang=pug"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=27e0c937&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-27e0c937"

export default script